import React, { createElement } from 'react';
export class H5VideoManager {
    public video: HTMLVideoElement;
    public title: string = '';
    public epname: string = '';
    public singer: string = '';
    public coverImgUrl: string = '';
    constructor() {
        this.video=document.createElement('video');
        this.video.preload = 'auto';
        this.video.width=document.body.offsetWidth;
    }
    public get duration () {
        return this.video.duration;
    }
    public get currentTime () {
        return this.video.currentTime;
    }
    public get src () {
        return this.video.src;
    }
    public set src (value) {
        this.video.src = value;
        this.video.load();
    }
    public get poster () {
        return this.video.poster;
    }
    public set poster (value:any) {
        this.video.poster = value;
    }
    public get state () {
        return this.video.readyState;
    }
    public get playbackRate () {
        return this.video.playbackRate;
    }
    public set playbackRate(value) {
        this.video.playbackRate = value;
    }
    public onNext = (): void => {}
    public onPrev = (): void => {}
    public onEnded = (callback?: () => void): void => {
        this.video.onended = callback as any;
    }
}